import {
    UNIVERSAL_SEARCH_HEADER_PREVIEW,
    VARIANT_ON,
} from '../../config/ab/experiments';

export const isUniversalSearchHeaderPreviewVariant = ({ ab }) => {
    return ab[UNIVERSAL_SEARCH_HEADER_PREVIEW.experimentId] === VARIANT_ON;
};
